import angular from 'angular';
export class ZipcodeService {
    constructor($http, $q, zipcodeApi) {
        this.$http = $http;
        this.$q = $q;
        this.zipcodeApi = zipcodeApi;
    }
    getCityState(zipcode) {
        const url = `https://www.zipcodeapi.com/rest/${this.zipcodeApi.clientKey}/info.json/${zipcode}/radians`;
        return this.$http.get(url);
    }
}
export default angular
    .module('doxy.common.services.zipcodeService', [])
    .service('zipcodeService', ZipcodeService).name;
